export default "__VITE_ASSET__352e271a__"